import type { AxiosInstance } from 'axios'
import authService from './modules/auth'
import accountService from './modules/account'
import subAccountService from './modules/subAccount'
import walletService from './modules/wallet'
import messageService from './modules/message'
import applicationService from './modules/application'
import invitationService from './modules/invitation'
import extractorService from './modules/extractor'
import commonService from './modules/common'

export default (axios: AxiosInstance) => ({
    common: commonService(axios),
    auth: authService(axios),
    account: accountService(axios),
    subAccount: subAccountService(axios),
    wallet: walletService(axios),
    message: messageService(axios),
    application: applicationService(axios),
    invitation: invitationService(axios),
    extractor: extractorService(axios),
})
